import React from "react";
import { useTranslation } from "react-i18next";
import Export from "../../assets/dashboard/export.svg";

const CTA = () => {
  const { t } = useTranslation();
  // Static data for the table
  const data = [
    {
      id: 1,
      copy: "Tell me what you think!",
      views: 200,
      reactions: 100,
    },
    {
      id: 2,
      copy: "More details coming soon!",
      views: 180,
      reactions: 90,
    },
    {
      id: 3,
      copy: "See you there!",
      views: 150,
      reactions: 70,
    },
    {
      id: 4,
      copy: "Curious to hear your feedback.",
      views: 140,
      reactions: 80,
    },
    {
      id: 5,
      copy: "Drop a portfolio link!",
      views: 120,
      reactions: 50,
    },
  ];

  return (
    <div className="border border-gradient-04 rounded-2xl p-2 md:p-4 shadow-sm bg-white">
      {/* Header */}
      <div className="flex justify-between items-center mb-4 pb-2 border-b">
        <h2 className="font-bold text-lg text-black-800 uppercase">CTA</h2>
        <span className="text-sm text-black-400">Views vs. Reactions</span>
      </div>

      {/* Table Header */}
      <div className="grid grid-cols-[0.5fr,3fr,1fr,1fr] md:grid-cols-[0.5fr,3fr,1fr,1fr] gap-4 text-sm md:text-xl font-bold text-black-600 text-left pb-2 border-b">
        <div>#</div>
        <div>{t("buttons.copy")}</div>
        <div className="text-right">Views</div>
        <div className="text-right">Reactions</div>
      </div>

      {/* Table Rows */}
      {data.map((item) => (
        <div
          key={item.id}
          className="grid grid-cols-[0.5fr,3fr,1fr,1fr] md:grid-cols-[0.5fr,3fr,1fr,1fr] gap-4 py-4 border-b last:border-b-0 text-lg text-black-600"
        >
          <div className=" font-bold">{item.id}</div>
          <div>{item.copy}</div>
          <div className="text-right">{item.views}</div>
          <div className="text-right">{item.reactions}</div>
        </div>
      ))}

      {/* Footer with a button */}
      <div className="flex justify-end pt-4">
        <button className="p-3 mb-2 bg-black-0 hover:bg-black-20 focus:bg-black-40 border-2 border-black-600 rounded group relative">
          <img src={Export} alt="Export" />
          <div className="absolute top-12 left-1/2 -translate-x-1/2 mr-2 px-2 py-1 bg-gray-800 text-white text-xs shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10 whitespace-nowrap uppercase">
            Export
            <div className="absolute left-1/2 bottom-full border-4 border-transparent border-b-gray-800"></div>
          </div>
        </button>
      </div>
    </div>
  );
};

export default CTA;
